(function () {
  function getScope(element) {
    return element.closest('[data-vp-product-scope]');
  }

  function getQuantityInput(scope, table) {
    var selector = table.dataset.vpQtySelector || 'input[name="quantity"]';
    return scope ? scope.querySelector(selector) : null;
  }

  function highlightTable(table, quantity) {
    table.querySelectorAll('[data-vp-row]').forEach(function (row) {
      var min = parseInt(row.dataset.minQty, 10);
      var max = row.dataset.maxQty ? parseInt(row.dataset.maxQty, 10) : Infinity;
      row.classList.toggle('is-active', quantity >= min && quantity <= max);
    });
  }

  function updateScope(scope) {
    if (!scope) return;

    scope.querySelectorAll('[data-vp-table]').forEach(function (table) {
      var input = getQuantityInput(scope, table);
      var quantity = input ? parseInt(input.value, 10) : NaN;
      if (!isNaN(quantity)) highlightTable(table, quantity);
    });
  }

  function updateAllScopes() {
    document.querySelectorAll('[data-vp-product-scope]').forEach(updateScope);
  }

  document.addEventListener('DOMContentLoaded', updateAllScopes);

  document.addEventListener('click', function (event) {
    var row = event.target.closest('[data-vp-row]');
    if (!row) return;

    var table = row.closest('[data-vp-table]');
    var scope = table && getScope(table);
    var input = scope && getQuantityInput(scope, table);
    var minQuantity = parseInt(row.dataset.minQty, 10);

    if (!input || isNaN(minQuantity)) return;

    input.value = minQuantity;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    var scope = getScope(event.target);
    if (!scope) return;

    scope.querySelectorAll('[data-vp-table]').forEach(function (table) {
      var selector = table.dataset.vpQtySelector || 'input[name="quantity"]';
      if (event.target.matches(selector)) {
        var quantity = parseInt(event.target.value, 10);
        if (!isNaN(quantity)) highlightTable(table, quantity);
      }
    });
  });

  document.addEventListener('input', function (event) {
    var scope = getScope(event.target);
    if (!scope || !event.target.matches('input[name="quantity"]')) return;
    updateScope(scope);
  });

  window.addEventListener('themeQuickshopOpened', updateAllScopes);
})();
